export default {
  getPrivacyPolicy: (state) => state.privacyPolicy,
  getPrivacyPolicyIsError: (state) => state.status.isError,
  getPrivacyPolicyError: (state) => state.status.error,
  getPrivacyPolicyIsLoading: (state) => state.status.isLoading
};
